import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { PersistGate } from 'redux-persist/integration/react';
import ReactGA from'react-ga4';
import { TRACKING_ID } from './env';
// import { IntlProvider } from 'react-intl';
import { store, persistor } from './redux/store';
import { useTheme } from './assets/styles/theme';
// import i18n from './localization/i18n';
import { MessageTip } from './components/messageTip';
import './assets/styles/animation.css';
import './assets/styles/main.css';
import MainRouter from './route/MainRouter';

const AccountTip = React.lazy(() => import('./components/accountTip'));
const TkShopTip = React.lazy(() => import('./components/tkShopTip'));

if(window.location.hostname !== "localhost"){
  ReactGA.initialize(TRACKING_ID);
  let local = localStorage.getItem("persist:root") || "{}";
  let jsons = JSON.parse(local);
  let auth_str = jsons.auth || "{}";
  let auth = JSON.parse(auth_str);
  let user = auth.user;
  if(user){
    ReactGA.set({
      'user_id': user.email,
      'user_properties': {
        'user_name': user.name,
        'user_email': user.email,
        'tiktok_account': user.tiktok_account,
        'created_at': user.created_at,
      }
    })
  }
}

function App() {
  const theme = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <IntlProvider
        messages={i18n.getMessages(lang)}
        key={lang}
        locale={lang}
        defaultLocale={i18n.getDefaultLocale()}
      > */}
        {/* <GoogleOAuthProvider clientId="676781562441-khp1bkcdo47oo6u7dlfml1qu3jldqcpf.apps.googleusercontent.com"> */}
          <MainRouter />
          <MessageTip />
          <Suspense>
            <AccountTip />
            <TkShopTip />
          </Suspense>
        {/* </GoogleOAuthProvider> */}
      {/* </IntlProvider> */}
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <ReduxProvider store={store}>
      <PersistGate persistor={persistor} loading={<></>}> {/*  */}
        <App />
      </PersistGate>
    </ReduxProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
